import axiosInstance from "./axiosSetup";
import { toast } from "react-toastify";

export const previewFile = async (backendUrl: string, fileName: string) => {
    try {
        const response = await axiosInstance.get(backendUrl, {
            responseType: 'blob',
        });

        const contentType = response.headers["content-type"] || "application/octet-stream";
        const blob = new Blob([response.data], { type: contentType });
        const blobUrl = URL.createObjectURL(blob);

        const previewableTypes = [
            "application/pdf", "image/png", "image/jpeg",
            "image/webp", "text/plain", "text/html"
        ];

        if (previewableTypes.includes(contentType)) {

            const previewWindow = window.open(blobUrl, "_blank");
            if (!previewWindow) {
                toast.error("Popup blocked. Please allow popups.");
            }
        } else {
            try {

                const downloadLink = document.createElement("a");
                downloadLink.href = blobUrl;
                downloadLink.download = fileName;
                downloadLink.click();
                toast.warning("Preview not supported for this file. Downloading instead.");
            } catch (error) {
                console.log("Download failed", error);
                toast.error("Failed to download file");
            }
        }

        // console.log("response headers ", response.headers)
    } catch (err) {
        console.log("Secure preview failed", err);
        toast.error("Failed to preview file");
    }
};
